import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './sierras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/260210/sierras-le_mclaren26-papaya--{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
